export const NAME = 'name'
export const STORES = 'media_store_ids'
export const FOOTFALL_AREA_ACTIVE_STATUS = 'active'
